import React from 'react';
import useGetData from 'components/common/useGetData';
import { userNotificationLog } from "hooks/api/myplanapi";
import { List, Row, Col, Empty, Spin, Skeleton } from 'antd';
import moment from 'moment';
import { ImagePaths } from 'utils/ImagePath';
import { EmployeeDetails } from 'components/common/CommonComponent';

const NotificationLog = () => {
    const [data, message, refetch, loading] = useGetData(userNotificationLog);

    const getStatusIcon = (status) => {
        return status === "approved"
            ? ImagePaths.notifyApprove.default
            : ImagePaths.notifyReject.default;
    };

    const formatDate = (date) => {
        return date ? moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY hh:mm A") : "";
    };

    return (
        <>
            <div className="p-3 bg-white rounded-lg shadow-md h-full">
                <h2 className="text-sm font-semibold border-b pb-2 mb-4">Notification Log</h2>

                {loading ? (
                    // <div className="flex justify-center items-center h-[73vh]">
                    //     <Spin />
                    // </div>
                    <div className="space-y-3">
                        {Array.from({ length: 5 }).map((_, index) => (
                            <div key={index} className="py-3 border-b">
                                <Row gutter={16} align="top" className="w-full">
                                    <Col className="w-36 pr-4 border-r border-gray-200">
                                        <Skeleton.Avatar active size="default" shape="circle" />
                                    </Col>
                                    <Col flex="1" className="pl-4">
                                        <Skeleton active paragraph={{ rows: 2 }} title={false} />
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </div>
                ) : data?.length === 0 ? (
                    <Empty description="No notifications yet" />
                ) : (
                    <div className="overflow-y-auto h-[80vh] pr-2">
                        <List
                            dataSource={data || []}
                            pagination={{
                                pageSize: 20,
                                showSizeChanger: false, 
                                showQuickJumper: true,  
                            }}
                            renderItem={(item) => {
                                const { employee } = item;
                                let empDetails = {
                                    title: employee.title || "",
                                    first_name: employee.employee_name || "",
                                    last_name: "",
                                    designation_id: {
                                        id: employee.designation?.id || "",
                                        designation_name: employee.designation?.name || ""
                                    },
                                    id: employee.employee_id,
                                    profile: employee.profile
                                };

                                return (
                                    <List.Item className="py-3 border-b">
                                        <Row gutter={16} align="top" className="w-full">
                                            {/* Left: Employee Info */}
                                            <Col className="w-40 pr-4 border-r border-gray-200">
                                                <EmployeeDetails details={empDetails} />
                                            </Col>

                                            {/* Right: Notification Content */}
                                            <Col flex="1" className="pl-4">
                                                <div className="flex items-center justify-between mb-1">
                                                    <p className="text-xs font-medium text-black">
                                                        {item?.title || "-"}
                                                    </p>
                                                    <img
                                                        src={getStatusIcon(item?.status)}
                                                        alt={`${item?.status || "notification"} icon`}
                                                        className="w-5 h-5 object-contain"
                                                    />
                                                </div>
                                                <p className="text-gray-600 text-xs mb-1">
                                                    {item?.message || "-"}
                                                </p>
                                                <p className="text-right text-xs text-gray-400">
                                                    {formatDate(item?.time)}
                                                </p>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                );
                            }}
                        />
                    </div>
                )}
            </div>
        </>

    );
};

export default NotificationLog;
